var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"shadow pa-2 pa-sm-6",attrs:{"loading":_vm.loading}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }